/* NSK sheep ship bar v2 (2026-11-02). Vanilla JS, no app.
   The lamb trots to Jesus (arms wide, the 99 behind Him); at A$150+ He hugs it.
   Listens to: the drawer's own bar updates (MutationObserver on [data-nsk-ship-fill] and the subtotal),
   'nsk:cart-updated' (detail = cart), common theme cart events, and refetches /cart.js. */
(function(){
  var root=document.getElementById('nskFlock'); if(!root) return;
  var ship=document.getElementById('nskCartShip'); if(ship) ship.classList.add('has-flock');
  var T=parseInt(root.getAttribute('data-thresh'),10)||15000;
  var NEAR=4000; /* within A$40 = "near" */
  var field=root.querySelector('.nskflock__field'), img=root.querySelector('.nskflock__img'),
      msg=root.querySelector('[data-flock-msg]'), sub=root.querySelector('[data-flock-sub]');
  var SRC={trot:root.getAttribute('data-trot'),stand:root.getAttribute('data-stand'),hop:root.getAttribute('data-hop')};
  var RM=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var last=parseInt(root.getAttribute('data-total'),10)||0, first=true, timer=null, t2=null;
  [SRC.trot,SRC.hop,SRC.stand].forEach(function(s){var i=new Image();i.src=s;});
  function money(c){return 'A$'+(c/100).toFixed(2);}
  function copy(total){
    var rem=Math.max(0,T-total);
    if(rem<=0) return {s:'done',m:'<b>Found &amp; home.</b> Free AU shipping unlocked',
      u:'\u201CRejoice with me; for I have found my sheep which was lost.\u201D Luke 15:6 KJV. Free AU shipping on orders over A$150, applied at checkout.'};
    if(rem<=NEAR) return {s:'near',m:'So close. <b>'+money(rem)+'</b> more and the flock ships free',
      u:'Nearly home to the Shepherd. One more piece and the lamb\u2019s in His arms. Free AU shipping on orders over A$150.'};
    return {s:'under',m:'<b>'+money(rem)+'</b> more and the flock ships free',
      u:'He left the 99 for the one. Free AU shipping on orders over A$150.'};
  }
  function celebrate(){
    root.classList.remove('is-hop'); void root.offsetWidth; root.classList.add('is-hop');
    clearTimeout(t2); t2=setTimeout(function(){root.classList.remove('is-hop');},2100);
  }
  function update(total){
    if(typeof total!=='number'||isNaN(total)) return;
    var c=copy(total), pct=Math.min(100,Math.round(total/T*100)), prevState=root.getAttribute('data-state');
    msg.innerHTML=c.m; sub.textContent=c.u;
    field.style.setProperty('--p',pct); field.setAttribute('aria-valuenow',String(pct));
    root.setAttribute('data-state',c.s);
    var moved=total!==last && !first;
    root.classList.toggle('is-back', moved && total<last && c.s!=='done');
    clearTimeout(timer);
    if(c.s==='done'){
      if(RM||first||prevState==='done'){
        root.setAttribute('data-home','1'); img.src=SRC.hop;
        if(!RM&&first&&prevState!=='done') celebrate();
      } else {
        /* trot the last stretch to Him, then the hug */
        root.removeAttribute('data-home'); img.src=SRC.trot;
        timer=setTimeout(function(){root.setAttribute('data-home','1');celebrate();},900);
      }
    } else {
      root.removeAttribute('data-home'); root.classList.remove('is-hop');
      img.src=RM?SRC.stand:SRC.trot;
      if(moved&&!RM) timer=setTimeout(function(){root.classList.remove('is-back');},950);
    }
    last=total; first=false;
  }
  function refresh(){
    fetch('/cart.js',{headers:{Accept:'application/json'},credentials:'same-origin'})
      .then(function(r){return r.json();}).then(function(c){update(c.total_price||0);}).catch(function(){});
  }
  var deb=null; function soon(){clearTimeout(deb);deb=setTimeout(refresh,80);}
  update(last);
  var fill=document.querySelector('#nskCartDrawer [data-nsk-ship-fill]');
  if(fill&&window.MutationObserver) new MutationObserver(soon).observe(fill,{attributes:true,attributeFilter:['style']});
  var sub2=document.querySelector('#nskCartDrawer [data-nsk-cart-sub]');
  if(sub2&&window.MutationObserver) new MutationObserver(soon).observe(sub2,{childList:true,characterData:true,subtree:true});
  document.addEventListener('nsk:cart-updated',function(e){var c=e&&e.detail; if(c&&typeof c.total_price==='number') update(c.total_price); else soon();});
  ['cart:updated','cart:refresh','cart-updated','theme:cart:change'].forEach(function(n){document.addEventListener(n,soon);});
  window.nskFlockUpdate=update;
})();
